import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { InferGetServerSidePropsType } from 'next';
import { Text, Layout, Translation, GoBackButton } from 'src/components';
import { trackEvent } from 'src/hooks';
import { getServerSidePropsForPage } from '../ssr/public';

type Error = InferGetServerSidePropsType<typeof getServerSidePropsForPage>;

export const Error = ({ clientConfig, translationStrings }: Error): JSX.Element => {
  const router = useRouter();

  useEffect(() => {
    trackEvent({
      name: 'ErrorScreen',
      data: { name: 'API error' },
    });
  }, []);

  return (
    <Layout clientConfig={clientConfig} translationStrings={translationStrings}>
      <Container>
        <Heading>
          <Text as="h1" weight="bold" size="xl">
            <Translation id="errorPage.title" />
          </Text>
        </Heading>
        <Text as="p" size="lg">
          <Translation id="errorPage.description" clientDisplayName={clientConfig.displayName} />
        </Text>
        <GoBackButton onClick={() => router.back()} />
      </Container>
    </Layout>
  );
};

export const getServerSideProps = getServerSidePropsForPage;

const Heading = styled.div`
  padding-bottom: var(--s-2);
`;

const Container = styled.div`
  padding: var(--s-4) var(--s-6) var(--s-6);
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export default Error;
